
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import 'animate.css'
import COVERAPP from '@/utils/COVERAPP'
import moment from 'moment'

@Options({
  data() {
    return {
      isShowRule: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'shareData', 'activityData', 'aid'])
  },
  mounted() {
    const _this = this;
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    homeShareData.link = window.location.href
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入首页')

    const serverTime = this.activityData.serverTime;
    const openLotteryApplyTime = this.activityData.templateConfig.openLotteryApplyTime;

    if (openLotteryApplyTime && moment(serverTime).unix() > moment(openLotteryApplyTime).unix()) {
      this.$common.getUser((res) => {
        const userinfo = JSON.parse(JSON.stringify(res));
        if (!userinfo || !userinfo.token) {
          return;
        }

        _this.SET_USERINFO(userinfo);
        _this.getRank(1);
      });
    }
  },
  methods: {
    ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
    handleAnswer(type) {
      const _this = this;
      if (!COVERAPP.Attribute.isApp()) {
        this.SET_DIALOGDATA({
          text: '参加该活动需在封面新闻APP中进行',
          btns: [
            {
                text: '取消',
                className : 'cancel-btn'
            },
            {
                text: '确定',
                className : 'download-btn'
            }
          ]
        })
        return;
      }

      this.$common.getUser((res) => {
        const userinfo = JSON.parse(JSON.stringify(res));
        if (!userinfo || !userinfo.token) {
          if (COVERAPP.Attribute.isApp()) {
            COVERAPP.Method.OpenLogin({
              callback(res) {
                if (res && res.token) {
                  _this.SET_USERINFO(res);
                  _this.goNotice(type);
                }
              }
            });
            return;
          }

          alert('请先登录~');
          return;
        }

        _this.SET_USERINFO(userinfo);
        _this.goNotice(type);
      });

    },
    async goNotice(type) {
      const statusText = {
        '2010': '答题未开始',
        '2011': '答题已结束',
        '2012': '已超过答题总数',
        '2013': '今日答题次数已用完，明日再来吧！',
        '2014': '今日答题次数已用完，明日再来吧！',
        '2015': '今日答题次数已用完，明日再来吧！'
      }

      const res = await this.$request('/answer/user/count', {
        aid: this.aid,
        match: type,
        userinfo: this.userInfo,
      }, 'post').catch(err => {
        this.$common.toast(statusText[err.errno] || res.errmsg || '网络错误~');
      });

      if (res.status === 0) {
        this.$router.push({
          name: 'Notice',
          query: {
            type,
          },
        })
      }
    },
    handleRank() {
      window.location.href = `/ptpanswer/#/rank?id=${ this.aid }`
    },
    async getRank(match) {
      const res = await this.$request('/answer/rank/self', {
        aid: this.aid,
        match,
        userinfo: this.userInfo,
      }, 'post').catch(err => {
        this.$common.toast(err.errmsg || '网络错误~');
        return;
      });

      if (res.rank <= 20) {
        window.location.href = `/apply/#/?id=${ this.aid }`;
      }
    },
  },
})
export default class Home extends Vue {}
